import React, { useEffect, useState } from "react";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { useForm,Controller } from "react-hook-form";
import Axios from "axios";
import Swal from 'sweetalert2';
import LoadingSpinner from "../helpers/loadingspinner.js";
import { GetJobRoles, JobPosting, GetListOfVendorsByEmployeeID, sitewebhookURL } from "../apiconstants/constants.js";
import ConsultantLayout from "../commonlayouts/consultantlayout.js";
import { Link, useLocation, useNavigate } from "react-router-dom";
import WYSIWYGEditor from "../helpers/WYSIWYGEditor.js"
import Select from 'react-select';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import logo from "../assets/images/knackhire-new.png"
function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const AddBulkJobPosts = () => {
    const { register, handleSubmit,control, formState: { errors, isSubmitting }, reset, setValue,watch } = useForm();
    const navigate=useNavigate();
let query = useQuery();
 const Guid = query.get("userguid"); 
 const selectedCountry = query.get("countryid");
  const vendorid = query.get("vendorid");
  const token = localStorage.getItem("jwtToken");
useEffect(() => {
  const url = new URL(window.location.href);
  const lowerUrl = url.origin + url.pathname + url.search.toLowerCase();
  if (lowerUrl !== window.location.href) {
    window.history.replaceState({}, document.title, lowerUrl);
  }
}, []);

    const [isDisabled, setIsDisabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [jobRoles, setJobRoles] = useState([]);
    const [showPreview, setShowPreview] = useState(false);
     const [jobType,setjobtype] = useState([
        {statusID:"1",statusName:"Work from Home"},
        {statusID:"2",statusName:"Work from Office"},
        {statusID:"3",statusName:"Hybrid"}])
        const [clientData, setClientData] = useState([]);
const [jobList, setJobList] = useState([]);
const [editorValue, setEditorValue] = useState("");
   const [outreach_Status_Type,setOutreach_Status_type] = useState([
      {status:"Not Required",typeName:"Not Required"},
            {status:"Not Started",typeName:"Not Started"},
            {status:"In-progress",typeName:"In-progress"},
            {status:"Completed",typeName:"Completed"}]);
             const [outreach_Type,setOutreach_type] = useState([
            {status:"Candidates",typeName:"Candidates"},
            {status:"Benchsales",typeName:"Benchsales"},
            {status:"Both",typeName:"Both"}]);
    const fetchJobRoles = () => {
    const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
        Axios.get(getApiUrl).then((response) => {
            setJobRoles(response.data);
        }).catch((error) => {
            console.error("Error fetching job roles", error);
        });

    };

    const GetVendorsList = () => {
      setIsLoading(true);
      const GetapiUrl = GetListOfVendorsByEmployeeID.APIURL + `?UserGuid=${Guid}&CountryID=${selectedCountry}`;
      Axios.get(GetapiUrl)
        .then((result) => {
          setIsLoading(false);
          setClientData(result.data);
        }).catch((error) => {
          console.log("Error" + error);
        });
    };
  
    const selectedVGuid = watch("clientVGuid");
const selectedClient = clientData.find(item => item.vGuid == selectedVGuid);

    const onSubmit = (data, e) => {
        e.preventDefault();
        setIsLoading(true);
        addData(data);
        reset();
    };
    const jobRoleOptions = jobRoles.map((item) => ({
      value: item.jobRoleId,
      label: item.jobRole
    }));

const addData = async (jobArray) => {
  if (!jobArray || jobArray.length === 0) {
    Swal.fire({
      icon: "warning",
      title: "Please add at least one job before submitting",
      timer: 2000,
      showConfirmButton: false,
    });
    return;
  }

  // ✅ Transform your job list into the correct format
  const finalParams = jobArray.map((job) => {
    const { vendorName, vGuid } = JSON.parse(job.selectedClient);
    return {
      title: job.title,
      positions: job.positions,
      location: job.location,
      jobType: job.jobType,
      clientName: vendorName,
      billRate: job.billRate,
      payRate: job.payRate,
      endClient: job.endClient,
      jobDescription: job.jobDescription,
      rolesAndResponsibilities: null,
      startDate: job.startDate,
      endDate: job.endDate,
      jobRoleID: job.jobRoleID?.value,
      vGuid: vGuid,
      userGuid: Guid,
      status: job.status,
      countryID: selectedCountry,
      outreach_Status: job.outreach_Status || "Not Started",
      outreach_Type:job.outreach_Type
    };
  });

  const apiAddUrl = JobPosting.APIURL;

  setIsLoading(true);
  Axios.post(apiAddUrl, finalParams, {
    headers: { 'Content-Type': 'application/json' },
   'Authorization': `Bearer ${token}`
  })
    .then((result) => {
      setIsLoading(false);
      if (result.data.message?.includes("added successfully")) {
         const n8nWebhookUrl = sitewebhookURL; // replace with your n8n URL
         fetch(n8nWebhookUrl, { method: "POST" }); // no need to await or handle response
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'All jobs submitted successfully',
          showConfirmButton: false,
          timer: 4000
        });

      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Some jobs not submitted',
          showConfirmButton: false,
          timer: 4000
        });
      }
    })
    .catch(() => {
      setIsLoading(false);
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Something went wrong, try again',
        showConfirmButton: false,
        timer: 4000
      });
    });
};


// ✅ 1️⃣ Fetch only once (no infinite loop)
useEffect(() => {
  fetchJobRoles();
  GetVendorsList();

  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0];
  const endDate = new Date();
  endDate.setDate(today.getDate() + 15);
  const formattedEndDate = endDate.toISOString().split("T")[0];

  setValue("startDate", formattedToday);
  setValue("endDate", formattedEndDate);
  setValue("jobType", "Hybrid");
  setValue("status", "Active");
}, [selectedCountry]); // ✅ removed clientData

useEffect(() => {
  if (vendorid && clientData.length > 0) {
    const matched = clientData.find(v => v.vGuid == vendorid);
    debugger
    if (matched) {
      const vendorOption = JSON.stringify({
        vendorName: `${matched.vendorName} - ${matched.vendorCompanyName}`,
        vGuid: matched.vGuid
      });

      setValue("selectedClient", vendorOption);

      // ✅ Ensure dropdown shows correct vendor immediately
      document.querySelector('select[name="selectedClient"]').value = vendorOption;
    }
  }
}, [vendorid, clientData, setValue]);



    return (
        <>
            <section>
        {
            isLoading ? <center><LoadingSpinner /></center> :
                        <div className="container-fluid mt-4 pb-5">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
  <h2 style={{ color: "#00a7ac", marginBottom: 0, marginTop: 8 }}>
    Add Job Posts
  </h2>
  <img src={logo} height={45} alt="Logo" style={{ marginTop: 8 }} />
</div>

                            <hr />
                            <div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                        <div class="row mt-2">
                                <form onSubmit={handleSubmit(onSubmit)} id="loginform">
                                    <div className="row p-3">
                                        <div className="row mt-0 p-2">
                                            <div className="col-12">
                                             
                                            <Controller
                                                 name="jobRoleID"
                                                 control={control}
                                                 rules={{ required: "Job Role required" }}
                                                 render={({ field }) => (
                                                   <Select
                                                     {...field}
                                                     options={jobRoleOptions}
                                                     placeholder="Select Job Role"
                                                     className={`basic-form ${errors.jobRoleID ? 'is-invalid' : ''}`}
                                                     styles={{
                                                       control: (provided, state) => ({
                                                         ...provided,
                                                         height: 50,
                                                         borderRadius: 15,
                                                         fontSize:12,
                                                         borderColor: errors.jobRoleID ? 'red' : provided.borderColor,
                                                       

                                                       })
                                                     }}
                                                   />
                                                 )}
                                               />
                                               {errors.jobRoleID && (
                                                 <div className="invalid-feedback d-block">{errors.jobRoleID.message}</div>
                                               )} </div>
                                        </div>
                                        
                  <div className="row mt-0 p-2">
                  <div className="col-12">                      
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Title</Tooltip>)}>
                <input type="text" name="title"  {...register("title", { required: "Title Required" })} placeholder="Title" className={`form-control basic-form  ${errors.title ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.title?.message}</div>
              </div></div>

              <div className="row mt-0 p-2">
              <div className="col-12">
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Positions</Tooltip>)}>
                <input type="number" name="positions"  {...register("positions", { required: "Positions Required" })} placeholder="Positions" className={`form-control basic-form  ${errors.positions ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.positions?.message}</div>
              </div>
              </div>

              <div className="row mt-0 p-2">
              <div className="col-12">
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Location</Tooltip>)}>
                <input type="text" name="location"  {...register("location", { required: "Location Required" })} placeholder="location" className={`form-control basic-form  ${errors.location ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.location?.message}</div>
              </div>
              </div>

              <div className="row mt-0 p-2">
    <div className="col-12">                                             
  <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Job type</Tooltip>)}>    

<select  {...register("jobType", { required: "Job Type Required" })} className={`form-control  mt-1 ${errors.jobType ? 'is-invalid' : ''}`} style={{height:50,borderRadius:15,fontSize:12}}  >
<option value="">Select Job Type</option>
{
jobType.map((item,index)=>
{
return(

<option key={index}  value={item.statusName}>{item.statusName}</option>

);
}

)
}
</select>
</OverlayTrigger>        
{ <div className="invalid-feedback">{errors.jobType?.message}</div> }

              </div>
              </div>    

              <div className="row mt-0 p-2">
                  <div className="col-12">                      
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Client Name</Tooltip>)}>          
          
<select
  {...register("selectedClient", { required: "Client Name Required" })}
  disabled={!!vendorid}
  className={`form-control mt-1 ${errors.selectedClient ? 'is-invalid' : ''}`}
  style={{ height: 50, borderRadius: 15, fontSize: 12 }}
>
  <option value="">Select Client Name</option>
  {clientData.map((item, index) => (
    <option
      key={index}
      value={JSON.stringify({
        vendorName: `${item.vendorName} - ${item.vendorCompanyName}`,
        vGuid: item.vGuid
      })}
    >
      {item.vendorName} - {item.vendorCompanyName}
    </option>
  ))}
</select>
    </OverlayTrigger>
             <div className="invalid-feedback"> {errors.selectedClient?.message}</div>
              </div></div>
                           <div className="row mt-0 p-2">
 <div className="col-12">                      
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> End Client Name</Tooltip>)}>
                <input type="text" name="endclient"  {...register("endClient")} placeholder = "End Client Name" className={`form-control basic-form`} />
              </OverlayTrigger>
              </div>
              </div>
              <div className="row mt-0 p-2">
                  <div className="col-12">                      
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> {selectedCountry == 1 ? 'Expected CTC' : 'Bill Rate'}</Tooltip>)}>
                <input type="text" name="billRate"  {...register("billRate", { required: "Bill Rate Required" })} placeholder={selectedCountry == 1 ? 'Expected CTC' : 'Bill Rate'} className={`form-control basic-form  ${errors.billRate ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.billRate?.message}</div>
              </div></div>
      
               <div className="row mt-0 p-2">
                   <div className="col-12">                      
                                            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> {selectedCountry == 1 ? ' Current CTC' : 'Pay Rate'}</Tooltip>)}>
                                            <input type="text" name="payRate"  {...register("payRate")} placeholder= {selectedCountry == 1 ? ' Current CTC' : 'Pay Rate'}  className={`form-control basic-form`} />
                                          </OverlayTrigger>
                                          </div></div>
         
                                        <div className="row mt-0 p-2">
                                            <div className="col-12">
                                                
<Controller
  control={control}
  name="jobDescription"
  rules={{
    required: { value: true, message: "Job Description Required" },
  }}
  render={({ field: { onChange, onBlur, value, ref } }) => {
    const handleEditorChange = (content) => {
 let sanitized = content
    // force remove inline fonts/sizes
    .replace(/font-family:[^;"]+;?/gi, "")
    .replace(/font-size:[^;"]+;?/gi, "")
    // remove empty paragraphs
    .replace(/<p[^>]*>(\s|&nbsp;)*<\/p>/gi, "")
    // unwrap <p> or <div> (with any attrs) inside list items
    .replace(/<li[^>]*>\s*(?:<p[^>]*>|<div[^>]*>)(.*?)<\/(?:p|div)>\s*<\/li>/gis, "<li>$1</li>")
    // remove a leading <br> inside li
    .replace(/<li[^>]*>\s*<br\s*\/?>\s*/gi, "<li>")
    // collapse multiple <br> into one
    .replace(/(<br\s*\/?>\s*){2,}/gi, "<br>");


  // wrap with Arial/12px
  const wrapped = `<div style="font-family: Arial; font-size: 12px;">${sanitized}</div>`;
onChange(wrapped);
setEditorValue(wrapped);

};


    return (
      <div>
        {/* Label + Button in one row */}
        <div className="d-flex align-items-center mb-2">
          <label style={{ color: "#00a7ac", margin: 0, }}>
            Job Description
          </label>
        <OverlayTrigger
  placement="right"
  overlay={<Tooltip id="preview-tooltip">
    {showPreview ? "Hide Preview" : "Show Preview"}
  </Tooltip>}
>
  <button
    type="button"
    className="btn btn-outline-primary btn-sm ml-3"
    onClick={() => setShowPreview(!showPreview)}
  >
    {showPreview ? <FaEye size={20} /> : <FaEyeSlash size={20} />}
  </button>
</OverlayTrigger>

        </div>

        {/* Editor */}
        <WYSIWYGEditor
        key={editorValue === "" ? Date.now() : undefined}
          onChange={handleEditorChange}
          onBlur={onBlur}
          value={editorValue}
          ref={ref}
          inputExtraProps={{
            required: true,
            style: { fontFamily: "Arial", fontSize: "12px" },
          }}
        />
        {errors.jobDescription && (
          <p
            style={{
              marginTop: "0.25em",
              fontSize: "80%",
              color: "#dc3545",
            }}
          >
            {errors.jobDescription.message}
          </p>
        )}

        {/* Preview Box */}
        {showPreview && value && (
          <div
            className="mt-3 p-3 border rounded"
            style={{ background: "#fafafa" }}
          >
            <h6 style={{ color: "#00a7ac" }}>Preview:</h6>
            <div
              style={{ fontFamily: "Arial", fontSize: "12px" }}
              dangerouslySetInnerHTML={{ __html: value }}
            />
          </div>
        )}
      </div>
    );
  }}
/>

                                            </div>
                                        </div>
                                   
      <div className="row mt-0 p-2">
      <div className="col-12">
       <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Start Date</Tooltip>)}>
                <input type="date" title="" name="startDate" {...register("startDate", { required: "Start Date Required" })} placeholder="Start Date" className={`form-control basic-form ${errors.startDate ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
            
              
              <div className="invalid-feedback">{errors.startDate?.message}</div>
              </div>
              </div>
            
              <div className="row mt-0 p-2">
              <div className="col-12">
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>End Date</Tooltip>)}>
                <input type="date" title="" name="endDate" {...register("endDate", { required: "End Date Required" })} placeholder="End Date" className={`form-control basic-form ${errors.endDate ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback">{errors.endDate?.message}</div>
              

              </div>
              </div>
              <div className="row mt-0 p-2">
              <div className="col-12">
          
              <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Post Status</Tooltip>)}>
<select  {...register("status", { required: "Status Required" })} className={`form-control ${errors.status ? 'is-invalid' : ''}`} style={{height:50 ,borderRadius:15,fontSize:12}} >
<option value="">Select Post Status</option>
<option value="Active">Active</option>
<option value="On Hold">On Hold</option>
<option value="Closed">Closed</option>
</select>
    </OverlayTrigger>  
                        <div className="invalid-feedback"> {errors.status?.message}</div>
                               
                                               <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Outreach Status</Tooltip>)}>
                                                     <select
                                 {...register("outreach_Status")}
                                 className={`form-control mt-3`}
                                 style={{ height: 50, borderRadius: 15, fontSize: 12 }}
                                 defaultValue="Not Started"
                               >
                                     <option value="">Select Outreach Status</option>
                                 {outreach_Status_Type.map((item, index) => (
                                   <option key={index} value={item.status}>
                                     {item.typeName}
                                   </option>
                                 ))}
                               </select>
                               </OverlayTrigger>
                                                             <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}>Select Outreach Type</Tooltip>)}>
                               
                                    <select
                                 {...register("outreach_Type")}
                                 className={`form-control mt-3`}
                                 style={{ height: 50, borderRadius: 15, fontSize: 12 }}
                               >
                                     <option value="">Select Outreach Type</option>
                               
                                 {outreach_Type.map((item, index) => (
                                   <option key={index} value={item.status}>
                                     {item.typeName}
                                   </option>
                                 ))}
                               </select>
                               </OverlayTrigger>
                                    </div>
                                    </div>  
                                          </div>
                                        
                                   
                                    <div className="row mb-4 mt-3 ">
                                        <div className="col-12"></div>
                                    </div>
                                    <Link to="/Employer/ListOfJobPosts"> 
                                     <button style={{ float: "right" }}  disabled={isSubmitting || isDisabled} className="btn btn-primary ">
                        Cancel
                      </button>
                      </Link>
                      <button
  id="svbutton"
  style={{ float: "right" }}
  disabled={isSubmitting || isDisabled}
  className="btn btn-primary pf-save mb-3 mr-3"
onClick={handleSubmit((data) => {
  let finalJobs = [...jobList];
  if (Object.keys(data).length > 0) {
    finalJobs.push(data); // keep as-is, parsing happens inside addData
  }
  addData(finalJobs);
})}

>
  {isSubmitting && (
    <span className="spinner-border spinner-border-sm mr-1"></span>
  )}
  Submit All ({jobList.length})
</button>
<button
  type="button"
  style={{ float: "right" }}
  className="btn btn-success pf-save mb-3 mr-3"
 onClick={handleSubmit((data) => {
  const { vendorName, vGuid } = JSON.parse(data.selectedClient);

  const newJob = {
    ...data,
    clientName: vendorName,
    vGuid,
    userGuid: Guid,
    countryID: selectedCountry,
    outreach_Status: "Not Started",
  };

  setJobList((prev) => [...prev, newJob]);

  // ✅ Reset fields except vendor & fixed dates
  reset({
    jobRoleID: "",
    title: "",
    positions: "",
    location: "",
    jobType: "Hybrid",
    jobDescription: "",
    startDate: data.startDate, // fixed 15 days
    endDate: data.endDate,     // fixed 15 days
    status: "Active",
    billRate: "",
    payRate: "",
    endClient: "",
    selectedClient: data.selectedClient, // keep same vendor
  });

  // ✅ Clear editor content & form control value both
  setEditorValue("");
  setValue("jobDescription", "");

  Swal.fire({
    icon: "success",
    title: "Job added to list",
    timer: 1500,
    showConfirmButton: false,
  });
})}

>
  <i className="fa fa-plus"></i> Add Job
</button>





 &nbsp;&nbsp;&nbsp;
                                </form>
                                </div>
                            </div>
                        </div>
                }
            </section>
        </>
    );
}

export default AddBulkJobPosts;
